import {logExperiment} from '@homeaway/abacus-client-utils';

import {
    hasEmptyDestinationValues,
    hasEmptyDatesValues,
    hasEmptyGuestsValues,
    hasValidDestinationValues,
    hasValidDatesValues,
    hasHPPageType,
    hasSLPPageType
} from './';

const EXPERIMENT_NAMES = [];

function getExperiment(abacus, experimentName) {
    return abacus.store.experimentData[experimentName];
}

/* istanbul ignore next */
function hasAllowableFullExposureExperiment() {
    return true;
}

function hasRunnableAnyVariantExperiment(experiment) {
    return experiment.value > 0;
}

function hasValidExperiment(experiment) {
    return !!experiment && !experiment.exception;
}

function hasAvailableExperiment(abacus, experimentName) {
    const experiment = getExperiment(abacus, experimentName);

    return hasValidExperiment(experiment);
}

function runExperiment(abacus, experimentName, {
    hasAllowableExperiment, // = hasAllowableFullExposureExperiment
    hasRunnableExperiment = hasRunnableAnyVariantExperiment
}) {
    const experiment = getExperiment(abacus, experimentName);

    if (hasValidExperiment(experiment) && hasAllowableExperiment(experiment)) {
        logExperiment(experiment);

        return hasRunnableExperiment(experiment);
    }

    return false;
}

function runHPPrePopulateCookieExperiment(abacus, system, cookies) {
    return runExperiment(abacus, 'HA_HP_SEARCHFORM_PRE_POPULATE_COOKIE', {
        hasAllowableExperiment() {
            const {
                destinationValues,
                datesValues,
                guestsValues
            } = cookies;

            return (
                hasHPPageType(system) && (
                    !hasEmptyDestinationValues(destinationValues) ||
                    !hasEmptyDatesValues(datesValues) ||
                    !hasEmptyGuestsValues(guestsValues)
                )
            );
        }
    });
}

function isHPDestinationEmptySearchErrorExperimentAvailable(abacus, system, destination) {
    const {
        latestValues
    } = destination;

    return (
        hasHPPageType(system) && (
            hasAvailableExperiment(abacus, 'HA_PTA_LANDING_DestinationlessError') &&
            !hasValidDestinationValues(latestValues)
        )
    );
}

function runHPDestinationEmptySearchErrorExperiment(abacus, system, form, destination) {
    return runExperiment(abacus, 'HA_PTA_LANDING_DestinationlessError', {
        hasAllowableExperiment() {
            const {
                settings: {
                    hasSubmitted,
                    wasLastSubmittedSuccessfully
                }
            } = form;

            const {
                latestValues
            } = destination;

            return (
                hasHPPageType(system) && (
                    !hasValidDestinationValues(latestValues) &&
                    hasSubmitted && !wasLastSubmittedSuccessfully
                )
            );
        }
    });
}

function runHPGuestPickerCTASearchExperiment(abacus, system, destination, dates) {
    return runExperiment(abacus, 'HA_PTA_SEARCHBOX_launchSearchFromGuestPickerCTA', {
        hasAllowableExperiment() {
            const {
                latestValues: destinationValues
            } = destination;

            const {
                latestValues: datesValues
            } = dates;

            return (
                hasHPPageType(system) && (
                    hasValidDestinationValues(destinationValues) &&
                    hasValidDatesValues(datesValues)
                )
            );
        }
    });
}

function runSLPDatePickerOpenedExperiment(abacus, system) {
    return runExperiment(abacus, 'HA_PTA_SEARCHFORM_SLP_Datepickeropened', {
        hasAllowableExperiment() {
            return hasSLPPageType(system);
        }
    });
}

/* istanbul ignore next */
function runAllExperiments() {
    const results = {};

    for (const experimentName of EXPERIMENT_NAMES) {
        results[experimentName] = runExperiment(experimentName);
    }

    return results;
}

export {
    EXPERIMENT_NAMES,
    getExperiment,
    hasAllowableFullExposureExperiment,
    hasRunnableAnyVariantExperiment,
    hasValidExperiment,
    hasAvailableExperiment,
    isHPDestinationEmptySearchErrorExperimentAvailable,
    runAllExperiments,
    runExperiment,
    runHPPrePopulateCookieExperiment,
    runHPDestinationEmptySearchErrorExperiment,
    runHPGuestPickerCTASearchExperiment,
    runSLPDatePickerOpenedExperiment
};
